export const menuItemFocusRing = 'focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gray-700'
